import { invalidateCachedResource, invalidateCachedResourcesMatching } from '@/features/charting-next/services/useRemoteResource';

const normalizeUid = uid => uid || 'anonymous';
const normalizeValue = value => (value ? String(value) : 'none');

export const chartingQueryKeys = {
  collection: (uid, signature) => ['charting', normalizeUid(uid), 'collection', normalizeValue(signature)],
  marketQuery: (uid, signature) => ['charting', normalizeUid(uid), 'market-query-v1', normalizeValue(signature)],
  ohlcSeries: (uid, ticker, resolution) => ['charting', normalizeUid(uid), 'ohlc-series', normalizeValue(ticker), normalizeValue(resolution)],
  favorites: uid => ['charting', normalizeUid(uid), 'favorites'],
  savedSearches: uid => ['charting', normalizeUid(uid), 'saved-searches'],
  metricPreferences: uid => ['charting', normalizeUid(uid), 'metric-preferences'],
  finderDefinition: (uid, finderName = '') => ['charting', normalizeUid(uid), 'finder-definition', normalizeValue(finderName)],
  fundamental: (uid, ticker) => ['charting', normalizeUid(uid), 'fundamental', normalizeValue(ticker)],
  fundamentalEmployees: (uid, ticker) => ['charting', normalizeUid(uid), 'fundamental-employees', normalizeValue(ticker)],
  alerts: (uid, ticker) => ['charting', normalizeUid(uid), 'alerts', normalizeValue(ticker)],
  registry: (uid, ticker) => ['charting', normalizeUid(uid), 'registry', normalizeValue(ticker)],
  streaming: () => ['charting', 'streaming']
};

export function invalidateChartingCollection(uid, signature) {
  return invalidateCachedResource(chartingQueryKeys.collection(uid, signature));
}

export function invalidateChartingMarketQuery(uid, signature) {
  return invalidateCachedResource(chartingQueryKeys.marketQuery(uid, signature));
}

export function invalidateChartingFavorites(uid) {
  return invalidateCachedResource(chartingQueryKeys.favorites(uid));
}

export function invalidateChartingWorkspaceMembership(uid) {
  return invalidateCachedResourcesMatching(key => {
    try {
      const parts = JSON.parse(key);
      return Array.isArray(parts) && parts[0] === 'charting' && String(parts[1]) === String(normalizeUid(uid))
        && ['favorites', 'collection', 'market-query-v1'].includes(parts[2]);
    } catch (_) { return false; }
  });
}

export function invalidateChartingSavedSearches(uid) {
  return invalidateCachedResource(chartingQueryKeys.savedSearches(uid));
}

export function invalidateChartingMetricPreferences(uid) {
  return invalidateCachedResource(chartingQueryKeys.metricPreferences(uid));
}

export function invalidateChartingAlerts(uid, ticker) {
  return invalidateCachedResource(chartingQueryKeys.alerts(uid, ticker));
}

export function invalidateChartingRegistry(uid, ticker) {
  return invalidateCachedResource(chartingQueryKeys.registry(uid, ticker));
}
